var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[(_vm.isDidacticMethods)?_c('didactic-methods-content',{attrs:{"section":_vm.section}}):_c('syllabus-objective-effects',{attrs:{"section":_vm.section}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }